import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import { generalSlice } from './generalSlice';
import { roomSlice } from './roomSlice';
import { uiSlice } from './uiSlice';

const makeStore = () =>
  configureStore({
    reducer: {
      [roomSlice.name]: roomSlice.reducer,
      [generalSlice.name]: generalSlice.reducer,
      [uiSlice.name]: uiSlice.reducer,
    },
    devTools: true,
  });

export type AppStore = ReturnType<typeof makeStore>;
export type AppState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action
>;

export const wrapper = createWrapper<AppStore>(makeStore);
